import { INewProduct } from '../../../interfaces/Product.interfaces';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

interface IGetNewProductParams {
  searchParam: {
    category: string;
  };
}

export const getNewProduct = ({ searchParam }: IGetNewProductParams): Promise<INewProduct> => {
  const URLSearchParams = createURLSearchParams(searchParam ?? {});
  return customAxios.get(`/market/new-product?${URLSearchParams}`);
};
